import {
    Component,
    Input,
    OnChanges
} from '@angular/core';
import { FooterListItemModel } from './report-dialog-footer.model';

@Component({
    selector: 'report-dialog-footer',
    templateUrl: './report-dialog-footer.component.html',
    styleUrls: ['./report-dialog-footer.component.scss']
})
export class ReportDialogFooterComponent implements OnChanges {
    @Input() footerList: FooterListItemModel[];
    @Input() footerWidth: string;
    calculatedFooterWidth: string;

    ngOnChanges() {
        this.footerList = this.footerList ? this.footerList : [];
        this.calculatedFooterWidth = `calc(${this.footerWidth} - 2em)`;
    }
}
